var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CHeader',{attrs:{"pHeaderProps":_vm.HeaderProps}},[_c('template',{slot:"Contenido"},[_c('FullCalendar',{attrs:{"id":"Agenda","options":_vm.calendarOptions}})],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }